"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'popupRecord',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        zuo_sn: this.$route.params.goods_sn,
        type: 1,
        start: 1,
        limi: 20,
        page_num: 1
      },
      selSnArr: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/eject_bao_record', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};